/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { gql, useQuery } from '@apollo/client';
import { Box, Button, Flex, Text } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import { ErrorSection, SanityRegion } from '../../../components';

export default function PreviewSanityRegion(props) {
  const { pageId } = props.params;
  const { data, loading, error /* , refetch */ } = useQuery(clientQuery, {
    variables: { id: pageId },
    fetchPolicy: 'network-only',
    pollInterval: 500,
    context: { clientName: 'sanity' },
  });
  if (loading)
    return (
      <Flex align="center" justify="center" sx={{ height: '100vh' }}>
        <Text>Loading Preview</Text>
      </Flex>
    );

  if (error) {
    return (
      <ErrorSection error={error}>
        <Text>
          Potential solution: Check that CORS is active for this site. Ensure
          that 'Allow Credentials' is checked.
        </Text>
        <Box sx={{ marginTop: 2 }}>
          <Button
            variant="primary"
            href={`https://www.sanity.io/manage/project/${process.env.GATSBY_SANITY_PROJECT_ID}/api`}
            target="_blank"
          >
            <Text>Go to Sanity project</Text>
          </Button>
        </Box>
      </ErrorSection>
    );
  }

  if (!data.Region)
    return (
      <ErrorSection error={{ message: 'Page not found' }}>
        <Text>
          Confirm that you are logged into your CMS, or this page doesn't exist.
          Try reloading this page preview from the CMS.
        </Text>
      </ErrorSection>
    );

  const { slug } = afterQuery(data);
  return (
    <Box>
      <Flex
        align="center"
        justify="center"
        sx={{ paddingY: 3, backgroundColor: '#f3f3f3' }}
      >
        <Text>
          This is a preview.{'  '}
          <a href={slug?.current !== 'index' ? `/${slug?.current}` : '/'}>
            View live version.
          </a>
        </Text>
      </Flex>
      <SanityRegion {...afterQuery(data)} />
    </Box>
  );
}

function afterQuery({ Region }) {
  return Region;
}

const clientQuery = gql`
  query ($id: ID!) {
    Region(id: $id) {
      ...SanityRegion
    }
  }
  ${SanityRegion.fragment}
`;
